import { useEffect, useState } from "react"
import { Button } from "react-aria-components"
import IconChevronRight from "../../../../../assets/icons/icon-chevron-right.svg"
import IconChevronUp from "../../../../../assets/icons/icon-chevron-up-blue.svg"
import IconChevronDown from "../../../../../assets/icons/icon-chevron-down-blue.svg"
import iconInfoBlue from "../../../../../assets/icons/icon-exclamation-blue.svg"
import { httpPost } from "../../../../../modules/Backend"
import Collapsible from "../../../../lib/Collapsible"
import { PropertyNames } from "../../../../../enums/PropertyNames"
import { FilterMatchType } from "../../../../../enums/FilterMatchType"
import { PropertyTypes } from "../../../../../enums/PropertyTypes"
import { IFilter } from "../../../../../hooks/UseFilters"
import { HistoryActionType } from "../../../../../enums/Domain/HistoryActionType"
import Pill, { IPillLookup } from "../../../Pill"
import { displayDateTime } from "../../../../../helpers/DateHelper"

interface ISidePanelAuditTrail {
    id: string,
    entityName: string,
    viewFunction: Function
}

interface IAuditTrail {
    action: string,
    from: string | undefined,
    to: string | undefined,
    userName: string,
    timeStamp: Date
}

export default function SidePanelAuditTrail({ id, entityName, viewFunction }: ISidePanelAuditTrail) {
    const [collapsed, setCollapsed] = useState<boolean>(true);
    const [data, setData] = useState<IAuditTrail[]>()
    const [loading, setLoading] = useState<boolean>(false);

    async function showData() {
        if (!data && !loading) await getData()
        else { setCollapsed(prev => !prev) }
    }

    async function getData() {
        setLoading(true)
        setCollapsed(false)
        const request = {
            filters: [
                {
                    propertyName: PropertyNames.entityName,
                    value: entityName,
                    required: false,
                    matchType: FilterMatchType.Equal,
                    type: PropertyTypes.entityName
                } as IFilter,
                {
                    propertyName: PropertyNames.id,
                    value: id,
                    required: false,
                    matchType: FilterMatchType.Equal,
                    type: PropertyTypes.uuid
                } as IFilter
            ],
            take: 5,
            keysets: []
        }

        var result = await httpPost(`api/audits/list`, request)

        setData(result.data.audits)
        setLoading(false);
    }

    useEffect(() => {
        setData(undefined);
        setCollapsed(true);
        setLoading(false)
    }, [id, entityName])

    return (
        <div className="side-panel-table__wrapper margin__top--s">
            <div className="display--flex flex__direction--row justifyContent--space-between padding__right--xxs">
                <div className="display--flex flex__direction--row alignItems--center padding__left--xxs ">
                    <p className="small">Audit trail</p>
                    <Button className={"button button--text-only button--with-icon "} onPress={() => viewFunction()}>
                        <p className="side-panel__button-text">View full details</p>
                        <div><img src={IconChevronRight} /></div>
                    </Button>
                </div>
                <Button className={"button button--with-icon alignSelf--baseline margin__right--xxs12"} onPress={showData}>
                    <img src={`${collapsed ? IconChevronDown : IconChevronUp}`}></img>
                </Button>
            </div>
            <Collapsible isCollapsed={collapsed}>
                <div className="side-panel-table__content">
                    {(data || loading) && (
                        <>
                            <div className="side-panel-table__header">
                                <p className="small">{data && data.length > 0 ? 'Change' : ''}</p>
                                <p className="small"></p>
                            </div>
                            {loading && !data ? (
                                <div className="side-panel-table__row">
                                    <div className="side-panel-table__cell-content padding__left--xxs">
                                        <div className="loaders loaders__list"></div>
                                    </div>
                                </div>
                            ) : data && data.length === 0 ? (
                                <div className="list--empty side-panel-table__blank-tint">
                                    <div className="display--flex flex"><img src={iconInfoBlue} /></div>
                                    <p>No history</p>
                                </div>
                            ) : (
                                <div className="side-panel-table__list">
                                    {data?.map((item, index) => (
                                        <div key={index} className="side-panel-table__row">
                                            <div className="side-panel-table__cell-content side-panel-table__cell-content--change padding__left--xxs">
                                                {renderAuditChange(item)}
                                            </div>
                                            <div className="side-panel-table__cell-content padding__left--xxs">
                                                {displayDateTime(item.timeStamp)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </Collapsible>

        </div>
    )
}

function renderAuditChange(value: any) {
    switch (value.action) {
        case HistoryActionType.status:
            {
                const lookup = {
                    statusName: value.statusLookupName,
                    statusKey: value.to

                } as IPillLookup;
                return <Pill statusDto={undefined} pillLookup={lookup} />
            }

        case HistoryActionType.location:
            return value.to && value.to.length > 0 ? <p className="breadcrumb">{value.to}</p> : undefined

        case HistoryActionType.notes:
            return <></>

        default:
            return <p className="small small--2">{value.to}</p>
    }
}